export const CACHE_EXPIRY_MINUTES = 60;
export const XL_LIST_LIMIT = 5000;
export const FORM_MAX_WIDTH = "1000px";
export const FORM_MIN_WIDTH = "300px";

export enum USER_PERMISSION {
  ADMIN = "ADMIN",
  TUTOR = "TUTOR",
  CLIENT = "CLIENT",
}

export enum COMPANY_USER_PERMISSION {
  ADMIN = "ADMIN",
  TUTOR = "TUTOR",
}

export const BOOKING_TYPE_SHORTCUTS = {
  "30-Free Minute Free Subject Eval": "30-Free Subject",
  "30 First Minute Free SAT/ACT Eval": "30-Free ACT/SAT",
  "Subject Tutoring": "Subject",
  "ACT/SAT Tutoring": "ACT/SAT",
} as const;

export const DEFAULT_BOOKING_TUTOR_PAY_RATE = 35;
export const ADMIN_ALERT_PHONE = "adminAlertPhone";
export const ADMIN_ALERT_EMAIL = "adminAlertEmail";

export const COLLEGE_ADVISING_INQUIRY_FORM =
  "https://docs.google.com/forms/d/1LwpcYn4i0Mn3hcpvtBaq2c6RY0CXHK36Y3JhKnjB7fc/edit";
export const COLLEGE_ADVISING_REGISTRATION_FORM_EMBED =
  "https://docs.google.com/forms/d/12Xa1MhUbmVyzpONN0Y5kWRHxofEqpY91D8_202RwZR8/edit";

export const COLLEGE_ADVISOR_EMAIL =
  window.location.hostname === "www.tutorthefuture.com"
    ? "cole@tutorthefuture.com"
    : "bmeilingsports@gmail.com";

export const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=tutor+the+future+reviews";
export const PUBLIC_STORAGE_BUCKET = "public-images";
export const CLIENT_ENGAGEMENT_VERSION = "1.0";
